import { REDIRECT_URL } from '@constants/routes';
import { useGenericMutation } from '@hooks/use-generic-mutation';
import { useQueryClient } from '@tanstack/react-query';
import { request } from '@utils/request/request';
import { RequestMethod } from '@utils/request/request.type';

import { AuthTokenResponse, useGetTokenQueryKey } from './type';
import { useTokenManagement } from './use-token-management';

export const requireRefreshedToken = async (refreshToken: string) => {
  const url = `${import.meta.env.VITE_AUTH_SERVICE_HOST}/v1/refresh-token`;

  return request({ url, method: RequestMethod.POST, body: { refreshToken } });
};

export const useRequireAuthTokens = ({ refreshToken }: { refreshToken: string }) => {
  const queryClient = useQueryClient();
  const { clearTokens } = useTokenManagement();

  return useGenericMutation<AuthTokenResponse>(
    [useGetTokenQueryKey],
    async () => requireRefreshedToken(refreshToken),
    {
      retry: 1,
      onSuccess: (data) => {
        if (data) queryClient.setQueryData([useGetTokenQueryKey], data);
      },
      onError: () => {
        clearTokens();
        const currentUrl = window.location.href;
        window.location.href = `${REDIRECT_URL}=${currentUrl}`;
      },
    },
    true,
    true
  );
};
